import { render, staticRenderFns } from "./LiveUserDistribution.vue?vue&type=template&id=486de6ff&scoped=true&"
import script from "./LiveUserDistribution.vue?vue&type=script&lang=js&"
export * from "./LiveUserDistribution.vue?vue&type=script&lang=js&"
import style0 from "./LiveUserDistribution.vue?vue&type=style&index=0&id=486de6ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486de6ff",
  null
  
)

export default component.exports